import { TranslationObject } from './en';

export const langSv: TranslationObject = {
  'common.expected_finish': 'Förväntat slut',
  'common.minutes': 'min',
  'common.now': 'Nu',
  'common.next': 'Nästa',
  'common.public_message': 'Offentligt meddelande',
  'common.scheduled_start': 'Planerad start',
  'common.scheduled_end': 'Planerad slut',
  'common.projected_start': 'Beräknad start',
  'common.projected_end': 'Beräknad slut',
  'common.stage_timer': 'Timer för scenen',
  'common.started_at': 'Började vid',
  'common.time_now': 'Klockan nu',
  'common.no_data': 'Inga tillgängliga data',
  'countdown.ended': 'Evenemanget avslutades vid',
  'countdown.running': 'Evenemang pågår',
  'countdown.select_event': 'Välj ett evenemang att följa',
  'countdown.to_start': 'Tid till start',
  'countdown.waiting': 'Väntar på att evenemanget ska starta',
  'countdown.overtime': 'i övertid',
  'timeline.live': 'live',
  'timeline.done': 'Avslutad',
  'timeline.due': 'Väntande',
  'timeline.followedby': 'Följt av',
  'project.title': 'Titel',
  'project.description': 'Beskrivning',
  'project.backstage_info': 'Backstageinformation',
  'project.backstage_url': 'Backstage-URL',
  'project.public_info': 'Offentlig information',
  'project.public_url': 'Offentlig URL',
};
